<template>
    <div class="form-group" v-if="IsShow">
        <h6 v-if="labelText">{{ labelText }}<span class="text-danger" v-if="validationRules"> *</span></h6>
        <span class="">{{ description }}</span>
        <validation-provider Name="Name" :rules="validationRules" v-slot="validationContext"
            :vid="ControlId ? ControlId : ''">
            <VueEditor v-model="temp_value" @input="updateValue" @text-change="textChange" ref="editor"
                useCustomImageHandler @image-added="handleImageAdded" :state="getValidationState(validationContext)"
                v-bind="$attrs" :editorToolbar="customToolbar"></VueEditor>
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ mandatoryText }}
            </b-form-invalid-feedback>
        </validation-provider>
        <slot name="footer"></slot>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { VueEditor } from 'vue2-editor';
import { fileUploadService } from "../../_services"
export default {
    props: ["value", "ControlId", "isshow", "mandatory", "title", "description", "placeholder", "CharLimit"],
    components: {
        VueEditor
    },
    data() {
        return {
            content: null,
            temp_value: this.value,
            IsShow: true,
            labelText: this.title,
            mandatoryText: this.mandatory,
            validationRules: this.rules == null ? (this.mandatory == null ? null : { required: true }) : this.rules,
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                // ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                // ["image"],
                ["link", "image"],
                // ["clean"] // remove formatting button
            ],
            maxlength: 0,
            minlength: 0,
            placeholderlabel: this.$t(this.placeholder),
            htmlText: "",
        }
    },

    computed: {
        ...mapGetters({
            GetPermissionJsonById: 'responsePermission/getPermissionJsonById',
        }),
        record() {
            return this.GetPermissionJsonById({ ControlId: this.ControlId })
        },
    },
    mounted() {
        //read from json
        if (this.record != null) {
            if (this.record.IsShow != null) this.IsShow = this.record.IsShow;
            if (this.record.IsMandatory) this.validationRules = { required: true };
            if (this.record.IsDisable != null) this.$attrs["disabled"] = this.record.IsDisable;
            if (this.record.Label != null) this.labelText = $t(this.record.Label);
            if (this.record.PlaceholderLabel != null) this.$attrs["placeholder"] = $t(this.record.PlaceholderLabel);
            if (this.record.MandatoryLabel != null) this.mandatoryText = $t(this.record.MandatoryLabel);
            if (this.record.MaxLength != null) { this.$attrs["maxlength"] = this.record.MaxLength };
            if (this.record.MinLength != null) { this.$attrs["minlength"] = this.record.MinLength };
        }
    },
    watch: {
        value() {
            this.temp_value = this.value;
        },
        placeholder() {
            this.placeholderlabel = this.$t(this.placeholder);
        }
    },
    methods: {
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        updateValue(e) {
            //Check if max length
            if (this.maxlength > 0) {
                if (this.temp_value.length > this.maxlength) {
                    this.$swal({
                        text: this.$t("lbl_EMPBE_ReachMaxLength"),
                        showCancelButton: false,
                        confirmButtonText: this.$t("lbl_EMPBE_Confirm")
                    })
                    return;
                }
            }
            //Check char CharOnly
            if (this.CharLimit == "CheckEnglishChar") {
                this.CheckEnglishChar()
            }
            this.$emit("input", this.temp_value);
        },
        textChange(delta, oldDelta, source) {
            if (this.CharLimit == "CheckEnglishChar") {
                var partn = new RegExp("[^\w\s\.\/,-_.:;$+#@?!'%^&℃()~≤≥αβ‰μπφΩΦευ*™ \"“”ö®’（）]", "gi");

                 console.log(partn.exec(this.temp_value))
                if (partn.exec(this.temp_value)) {
                    delta = oldDelta
                    this.$refs.editor.quill.setContents(delta)
                    console.log("check")
                }
            }
        },
        CheckEnglishChar() {
            this.$nextTick(() => {
                this.temp_value = this.temp_value.replace("®", "");
                var partn = new RegExp("[^\w\s\.\/,-_.:;$+#@?!'%^&℃()~≤≥αβ‰μπφΩΦευ*™\"“”ö®’（）]", "gi");
                if (partn.exec(this.temp_value)) {
                    // console.log("before:" + this.temp_value)
                    this.temp_value = this.temp_value.replace(/[^\w\s\.\/,-_.:;$+#@?!'%^&℃()~≤≥αβ‰μπφΩΦευ*™\"“”ö®’（）]/ig, '')
                    // console.log("after:" + this.temp_value)
                    this.$emit("input", this.temp_value);
                    
                }
                
            });
        },
        handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
            fileUploadService.uploadFile(file, "Image").then(result => {

                const url = result.data.cdnLnk
                Editor.insertEmbed(cursorLocation, "image", url);       
                resetUploader();
            })
        }
    }
}
</script>
<style>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
}
</style>